import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I couldn't get into YC so I joined a startup that did",
  "description": "",
  "published": "2011-06-24T00:00:00.000Z",
  "redirect_from": ["/blog/i-couldnt-get-into-yc-so-i-joined-a-startup-that-did/swizec/1855"],
  "categories": "Funds, Paul Graham, Start Up, Uncategorized, Y Combinator",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last year when I was still working on `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/doing-a-startup-taught-me-the-value-of-staying-in-school/swizec/1819",
        "title": "Doing a startup taught me the value of staying in school"
      }}>{`my first real startup`}</a>{` we tried to get into `}<a parentName="p" {...{
        "href": "http://www.ycombinator.com",
        "title": "Y Combinator"
      }}>{`YCombinator`}</a>{` because it seemed like a natural`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/300px-Wfm_palo_alto4.jpg",
        "alt": "University Avenue",
        "title": "University Avenue"
      }}></img></p>
    <p>{`thing to do at the time. We wanted to get into the US pretty much any way possible and what better approach than going through the awesomest incubator around? Sure seems easier than trying to do it without the big leg up.`}</p>
    <p>{`We didn't get in.`}</p>
    <p><em parentName="p">{`tl;dr --> if you're in Palo Alto and you're awesome, I want to meet you for coffee`}</em></p>
    <p>{`Ok, no biggie, you live and you learn.`}</p>
    <p>{`This year I applied again, with `}<a parentName="p" {...{
        "href": "http://hipstervision.org/"
      }}>{`HipsterVision`}</a>{` - a project that was only a couple of weeks old at the time and showing some promise of being awesome. I wrote a pretty decent application, likely better than the one I wrote last year.`}</p>
    <p>{`I didn't get in.`}</p>
    <p>{`Honestly, I shot myself in the foot both times. Looking back at both applications I'd say I was triggering pretty much every warning flag you can think of for not funding a startup. The fate of both projects also seems to indicate they made the right decision not to fund. Preona has become some sort of freelancing business, with a hint of a side project or two, in the hands of my cofounder; HipsterVision is sort of lingering on the sidelines with my not having enough time to give it the attention it needs and deserves.`}</p>
    <p>{`Real life sort of gets in the way and the truth is that a 20-something who intends to finish university simply has the odds stacked against him when it comes to starting and maintaining a business. Let alone a proper startup ... especially when real money has to be made. Not stocks, not options, not valuations, not even wealth. Cold hard cash. Turns out it's the only thing that puts food on the table.`}</p>
    <p>{`So in lieu of having a startup in YC right now, I did pretty much the next best thing.`}</p>
    <p>{`I joined an awesome team that got in!`}</p>
    <p>{`Right now I'm in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4291666667,-122.138055556&spn=0.1,0.1&q=37.4291666667,-122.138055556%20(Palo%20Alto%2C%20California)&t=h",
        "title": "Palo Alto, California"
      }}>{`Palo Alto`}</a>{`, writing this from the living room of a house that's just three houses down from `}<a parentName="p" {...{
        "href": "http://paulgraham.com",
        "title": "Paul Graham (computer programmer)"
      }}>{`Paul Graham`}</a>{`. It feels two parts awesome and five parts simply surreal. And I'm going to be here until the end of August!`}</p>
    <p>{`mind=blown!`}</p>
    <p>{`Literally. `}{`[`}{`it's actually figuratively]`}</p>
    <p>{`Although that could just be the jetlag talking. Been waking up at insanely early hours ever since I got here on Wednesday. Sure hope it goes away soon because it just feels silly ...`}</p>
    <p>{`Anyhow, here I am! The server-side javascript ninja of the team, learning as much as I can about running a successful startup (I already know how to run an unsuccessful one :P), and not having to worry about a single thing. It's the best of both worlds! And what do you know, maybe in a year or two I'll have the chops to get into YC on my own. Right now I'm just enjoying the liberating feeling of only having to focus on solving technical stuff.`}</p>
    <p>{`That said, anyone from the HackerNews/YCombinator crowd wanna grab a cup of coffee? I'd love to meet you guys in person.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://venturebeat.com/2011/06/13/y-combinator-partners-alums/"
        }}>{`Y Combinator's latest partners are also alums`}</a>{` (venturebeat.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2011/06/13/ycombinator-brings-on-alumni-to-be-part-time-partners/"
        }}>{`Y Combinator Brings On Alumni To Be "Part Time Partners"`}</a>{` (techcrunch.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thestartupfoundry.com/2011/04/11/wakemate-yc-s09-on-building-their-business-and-their-ycombinator-experience/"
        }}>{`WakeMate (YC S09) on building their business and their Y Combinator experience`}</a>{` (thestartupfoundry.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2011/05/24/y-combinators-paul-graham-were-looking-for-people-like-us/"
        }}>{`Y Combinator's Paul Graham: We're Looking For People Like Us`}</a>{` (techcrunch.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fb688708-83f3-4504-b27a-fd1eece4dd5e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      